<template>
  <div>
    <core-grid ref="grid" :onRead="onRead" :schema="schema"> </core-grid>
    <EmailSMTPAddEdit ref="editar" @close="response"></EmailSMTPAddEdit>
  </div>
</template>

<script>
export default {
  components: {
    EmailSMTPAddEdit: () => import('./EmailSMTPAddEdit')
  },
  data () {
    return {
      schema: [
        { value: 'host', text: 'Host' },
        { value: 'account', text: 'User' },
        { value: 'useSSL', text: 'SSL?', format: 'boolean' }
      ]
    }
  },
  methods: {
    onRead: function (options, search) {
      const dto = { parameters: [{ name: 'search', value: search }] }
      this.$api.EmailSMTP.Get(`GetAll?${dto}`).then(function (response) {
        options.success(response)
      })
    },
    refresh () {
      this.$refs.grid.refresh()
    },
    response (data) {
      if (data) {
        this.refresh()
      }
    },
    excluir (current) {
      const th = this
      if (current) {
        th.$api.EmailSMTP.Delete(current.id).then(function (data) {
          if (th.$api.UI.PostAction(data, `${current.id} removido com sucesso.`)) {
            th.refresh()
          }
        })
      }
    }
  }
}
</script>
